<!-- Default Testimonials -->
<div 
  class="testimonials-area-with-bg-image pt-10 pb-100"
  *ngIf="data"
>
    <div class="container">
        <div class="testimonials-slides">
            <owl-carousel-o [options]="testimonialsSlides">
                <ng-template carouselSlide *ngFor="let item of data">
                    <div class="single-testimonials-card">
                      <div class="testimonials-content">
                        <p>{{ item.attributes.content }}</p>
                        <div class="info">
                          <img [src]="item.attributes.client?.data?.attributes.image?item.attributes.client?.data?.attributes.image:'assets/images/testimonials-1.jpg'" alt="{{ item.attributes.client?.data?.attributes.name }}" />
                          <h3>{{ item.attributes.client?.data?.attributes.name }}</h3>
                          <span>{{ item.attributes.client?.data?.attributes.role }} chez <strong>{{ item.attributes.client?.data?.attributes.company }}</strong></span>
                        </div>
                      </div>
                    </div>
                  </ng-template>                  
            </owl-carousel-o>
        </div>
    </div>
    <!--<div class="testimonials-goca"><img src="assets/images/afrotech-logo-smallest.png" alt="image"></div>-->
</div>
